export const interactiveTableRowSx = {
  cursor: 'pointer',
  '--sr-table-row-bg': 'var(--table-row-base)',
  backgroundColor: 'var(--sr-table-row-bg)',
  transition: 'background-color 120ms ease',
  '&:nth-of-type(even)': {
    '--sr-table-row-bg': 'var(--table-row-alt)',
  },
  '&:hover': {
    '--sr-table-row-bg': 'var(--table-row-hover-strong)',
  },
  '& > .MuiTableCell-root': {
    backgroundColor: 'var(--sr-table-row-bg)',
    transition: 'background-color 120ms ease',
  },
};
